export default __webpack_public_path__ + "static/media/team-4.98a08964.png";